import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppState, AppDispatch } from '../store';
import { provinceDataConstants } from '@constants/provinceconstants';
import { newProvinceConstants } from '@constants/newprovinceconstants';
import {
  fetchModuleList,
  fetchBankSupportList,
  fetchSchoolModuleList,
  fetchUserDetail,
  fetchNewWardList,
} from '@store/actions/comonActions';
import {clearModuleList} from '@store/reducers/commonReducer';
export const useCommon = () => {
  const dispatch: AppDispatch = useDispatch();
  const districList = useSelector(
    (state: AppState) => state.school.districtList,
  );
  const showAIConversation = useSelector((state: AppState) => state.common.showAIConversation);
  const wardList = useSelector((state: AppState) => state.school.wardList);
  const schoolList = useSelector((state: AppState) => state.class.schoolList);
  const moduleList = useSelector((state: AppState) => state.common.moduleList);
  const newWardList = useSelector(
    (state: AppState) => state.common.newWardList,
  );
  const studentClassModuleList = useSelector((state: AppState) => state.common.studentClassModuleList);

  const userDetail = useSelector((state: AppState) => state.common.userDetail);

  // Transform classes to options format { label, value }
  const classOptions = useMemo(() => {
    if (!userDetail?.classes || !Array.isArray(userDetail.classes)) {
      return [];
    }
    return userDetail.classes.map((classItem: any) => ({
      label: classItem.class_name || '',
      value: classItem.id,
    }));
  }, [userDetail?.classes]);
  const loadingUserDetail = useSelector(
    (state: AppState) => state.common.loadingUserDetail,
  );
  const loadingModule = useSelector(
    (state: AppState) => state.common.loadingModule,
  );
  const bankSupportList = useSelector(
    (state: AppState) => state.common.bankSupportList,
  );
  const schoolModuleList = useSelector(
    (state: AppState) => state.common.schoolModuleList,
  );
  const provinceDataSelect = provinceDataConstants.map((province) => ({
    label: province.name,
    value: province.code,
  }));
  const newProvinceDataSelect = newProvinceConstants.map((province) => ({
    label: province.province_name_2,
    value: province.province_code_2,
  }));

  const districtDataSelect = districList.map((district: any) => ({
    label: district.full_name,
    value: district.code,
  }));

  const wardDataSelect = wardList.map((ward: any) => ({
    label: ward.full_name,
    value: ward.code,
  }));

  const schoolDataSelect = schoolList.map((school: any) => ({
    label: school.name,
    value: school.id,
  }));

  const bankSupportDataSelect = bankSupportList.map((bankSupport: any) => ({
    label: bankSupport.name,
    value: bankSupport.id,
  }));
  const moduleOptions = moduleList?.results?.map((module: any) => ({
    label: module.name,
    value: module.id,
  })) || [];

  const fetchModuleListAction = (filters: any) => {
    dispatch(fetchModuleList(filters));
  };

  const fetchBankSupportListAction = () => {
    dispatch(fetchBankSupportList());
  };
  const fetchUserDetailAction = (id: number) => {
    dispatch(fetchUserDetail(id));
  };

  const fetchSchoolModuleListAction = (filters: any) => {
    dispatch(fetchSchoolModuleList(filters));
  };

  const fetchNewWardListAction = (provinceId: string) => {
    dispatch(fetchNewWardList(provinceId));
  };

  const clearModuleListAction = () => {
    console.log('clearModuleListAction');
    dispatch(clearModuleList());
  };

  return {
    showAIConversation,
    provinceDataSelect,
    districtDataSelect,
    wardDataSelect,
    schoolDataSelect,
    bankSupportDataSelect,
    fetchModuleListAction,
    fetchBankSupportListAction,
    fetchSchoolModuleListAction,
    moduleList,
    bankSupportList,
    schoolModuleList,
    schoolList,
    fetchUserDetailAction,
    userDetail,
    loadingUserDetail,
    fetchNewWardListAction,
    newWardList,
    newProvinceDataSelect,
    loadingModule,
    studentClassModuleList,
    classOptions,
    moduleOptions,
    clearModuleListAction
  };
};
